import { KEYS } from '../../../../../l18n/constants';
import { useL18nContext } from '../../../ContextProvider/L18n';
import { usePartnerSearchContext } from '../../../ContextProvider/Partner/Search';
import useEloquaURLs from '../../../../../hooks/data/useEloquaURLs';

import computeClassName from '../../../../../utils/computeClassName';

import PartnerNameAndAddress from '../../../Partner/NameAndAddress';
import PartnerMap from '../../../Partner/Map';
import CCFormInputButtonPrimary from '../../../../libs/CiscoCore/Form/Input/Button/Primary';
import CCFormInputButtonSecondary from '../../../../libs/CiscoCore/Form/Input/Button/Secondary';
import computeTagName from '../../../../../utils/computeTagName';

function openEloquaRequestAQuote(requestAQuoteURL) {
  return () => {
    window.open(requestAQuoteURL, '_blank');
  }
}

function openEloquaGetGuidance(getGuidanceURL) {
  return () => {
    window.open(getGuidanceURL, '_blank');
  }
}

const constants = Object.freeze({
  CLASSNAME_BASE: 'flex flex-row flex-wrap sm:flex-nowrap',
  TAG_DEFAULT: 'section'
});

const propsDefaults = Object.freeze({
  tag: constants.TAG_DEFAULT
});

export default function PartnerAddressContactDetailsMap(
  {
    partnerDetails,
    className = '',
    tag = propsDefaults.tag
  }
  ) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const ComputedTagName = computeTagName();

  const { getTranslationFor } = useL18nContext();
  const translatedLabelGetGuidance = getTranslationFor(KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE);
  const translatedLabelRequestAQuote = getTranslationFor(KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE);

  const partnerBeGeoId = partnerDetails?.be_geo_id;
  const { searchCriteria } = usePartnerSearchContext();

  const { isEloquaURLGenerationInProgress, eloquaURLGenerationErrors, eloquaUrls } = useEloquaURLs(partnerBeGeoId, searchCriteria);
  const showGetGuidance = !!(eloquaUrls?.guidance || '').length;
  const showRequestAQuote = !!(eloquaUrls?.quote || '').length;

  return (
    <ComputedTagName className={computedClassName}>
      <div className="w-full sm:w-1/3">
        <PartnerNameAndAddress className="mb-6"
                               partnerName={partnerDetails.partner_name}
                               partnerAddressLine1={partnerDetails?.site_addr_1 || ''}
                               partnerAddressLine2={'site_addr_2' in partnerDetails ? partnerDetails.site_addr_2 : ''}
                               partnerAddressLine3={'site_addr_3' in partnerDetails ? partnerDetails.site_addr_3 : ''}
                               partnerZipOrPostalCode={partnerDetails?.site_zip || ''}
                               partnerCity={partnerDetails?.site_city || ''}
                               partnerStateOrRegion={partnerDetails?.site_state || ''}
                               partnerCountry={partnerDetails?.site_country  || ''}
                               partnerWebSiteAddress={partnerDetails.web_addr || '' }
                               partnerPhoneNumber={partnerDetails?.site_phone || ''}/>
        {
            <>
              <CCFormInputButtonPrimary className="w-full mb-2"
                                        value={translatedLabelRequestAQuote}
                                        clickFn={openEloquaRequestAQuote(eloquaUrls?.quote)}
                                        isDisabled={!showRequestAQuote || isEloquaURLGenerationInProgress || eloquaURLGenerationErrors}/>
              <CCFormInputButtonSecondary className="w-full mb-16"
                                          value={translatedLabelGetGuidance}
                                          clickFn={openEloquaGetGuidance(eloquaUrls?.guidance)}
                                          isDisabled={!showGetGuidance || isEloquaURLGenerationInProgress || eloquaURLGenerationErrors}/>
            </>
        }
      </div>
      <div className="w-full sm:w-2/3 h-80 sm:ml-cc-18 relative">
        <PartnerMap googleMapURL="https://maps.googleapis.com/maps/api/js?v=3&client=gme-ciscopartnerlocator"
                    loadingElement= <div className="h-full"/>
                    containerElement=<div className="h-full"/>
                    mapElement=<div className="h-full" />
                    partnerDetails={partnerDetails}
                    partnerFullStreetAddress={partnerDetails?.site_addr_1 || ''}/>
      </div>
    </ComputedTagName>
  );

}
